module.exports = __webpack_public_path__ + "static/media/01C.34d88881.png";